var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalfFilledStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7V6H13V4H12V2H11V0H9V2H8V4H7V6H6V7H0V9H1V10H2V11H3V12H4V16H3V18H2V20H5V19H7V18H8V17H12V18H13V19H15V20H18V18H17V16H16V12H17V11H18V10H19V9H20V7H14ZM14 11V10H15V9H12V8H11V6H10V12.5714V14H12V15H14V13H13V11H14Z",
    fill: "#F89344"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfFilledStar);
export default __webpack_public_path__ + "static/media/half_filled_star.900db915a033a69095d4945545d2db85.svg";
export { ForwardRef as ReactComponent };